export default "__VITE_ASSET__CC6zMSVk__"